// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { NewTabLink } from "@/components/Link/NewTabLink";

type UserAgreementLinksProps = {
  linkColor?: string;
};

export const UserAgreementLinks = ({ linkColor }: UserAgreementLinksProps) => {
  const linkSx = linkColor ? { color: `${linkColor} !important` } : undefined;

  return {
    zeffyTerms: <NewTabLink href="https://support.zeffy.com/terms-of-use-for-users" display="inline" sx={linkSx} />,
    zeffyPrivacy: <NewTabLink href="https://support.zeffy.com/data-privacy-policy" display="inline" sx={linkSx} />,
  };
};
